import Cookies from 'js-cookie';
import 'firebase/auth';
import logger from '../logger';
import authLog from './authDebugLog';
import { DRYNOTES_LOGIN, COOKIE_KEYS } from '../constants';
import { validateFirebaseAuth, signOutAndRedirect } from './firebaseAuth';

export const getOwnerID = () => {
  const ownerID = Cookies.get(COOKIE_KEYS.userID);
  return ownerID;
};

/**
 * return Returns a JSON Web Token (JWT) used to identify the user to a Firebase service;
 */
export const getOwnerJWT = () => Cookies.get(COOKIE_KEYS.jwt);

/**
 * Enhanced authentication check that validates Firebase auth state
 * This replaces the simple cookie check with proper Firebase validation
 */
export const isLoggedIn = async () => {
  try {
    // First check if we have the basic cookie
    const ownerID = getOwnerID();
    const jwt = getOwnerJWT();
    authLog('isLoggedIn:check', { hasOwnerID: !!ownerID, hasJwt: !!jwt });
    if (!ownerID) {
      logger.debug('No userID cookie found');
      authLog('isLoggedIn:no-owner-id');
      return false;
    }

    // Then validate with Firebase
    const isValid = await validateFirebaseAuth();
    authLog('isLoggedIn:result', { isValid });
    return isValid;
  } catch (error) {
    logger.error('Error checking authentication status:', error);
    authLog('isLoggedIn:error', { error: String(error) });
    return false;
  }
};

/**
 * Synchronous version for backward compatibility
 * Note: This is less reliable than the async version
 */
export const isLoggedInSync = () => {
  const ownerID = getOwnerID();
  const jwt = getOwnerJWT();

  // Basic check - but this doesn't validate the JWT
  return !!(ownerID && jwt);
};

export const logOut = () => {
  // Use the new Firebase-aware logout function
  signOutAndRedirect();
};

// Save a cookie
export const saveCookie = (options) => {
  const { name, value, ttl, domain } = options;
  logger.debug(options, 'saveCookie');
  Cookies.set(name, value, {
    expires: ttl,
    domain,
    secure: true,
    sameSite: 'strict',
  });
};

const DryCookies = {
  getOwnerID,
  getOwnerJWT,
  isLoggedIn,
  isLoggedInSync,
  logOut,
  saveCookie,
};

export default DryCookies;
